var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"app",staticClass:"app",attrs:{"id":"app"}},[(_vm.name != 'blank')?_c('Header'):_vm._e(),_c('router-view'),_c('div',{staticClass:"flex1"}),(_vm.name != 'blank')?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }